import { useSelector } from 'react-redux';
import { selectUserInfoData } from '../../../reducers/userInfoReducer';
import { AccountType } from '@server/account-type';
import { useFeatureToggle } from '../../../feature-flags/useFeatureToggle';

export const useIsSIUser = (): boolean => {
  const userInfo = useSelector(selectUserInfoData);
  const { assessments: isAssessmentsEnabled } = useFeatureToggle();

  return isAssessmentsEnabled && userInfo?.account?.type === AccountType.SI;
};
